// OrellaThinkingBubble — v225.26.0
// A conversational "Orella is working" loader: the navy Orella O wrapped in a
// spinning blue ring (loader + identity as one element) beside an ice-blue chat
// bubble with the message + typing dots. Used as a beat in the same chat flow as
// OrellaChatBubble — e.g. the Describe voice-memo extraction wait and the
// ViewSummary case-analysis wait — so loading never reads as a blank/error void.
//
// Shared single source of truth: both loaders render identically and can't drift.
// Callers supply their own context-appropriate skeleton below this bubble.

import { OrellaSpinner } from './OrellaLoader'
import { DIALOGUE_BUBBLE, DIALOGUE_PAD } from './agent/dialogueBubble'

export default function OrellaThinkingBubble({ message = 'Working on it', subMessage = '' }) {
  return (
    <div className="flex gap-2.5 items-start">
      <style>{`
        @keyframes orellaThinkDot { 0%,80%,100% { opacity:.3; transform:scale(.8); } 40% { opacity:1; transform:scale(1.15); } }
      `}</style>
      {/* ★ D332(q): the ring is OrellaSpinner's, not a copy of it. This file carried a
          byte-identical duplicate of OrellaLoader's ring — same track, head, sweep and
          glyph — which is a second definition of the mark, free to drift. */}
      <OrellaSpinner size={36} className="flex-shrink-0" />
      <div className={`flex-1 min-w-0 ${DIALOGUE_BUBBLE} ${DIALOGUE_PAD}`}>
        <div className="flex items-center gap-2">
          <p className="text-[15.5px] font-medium leading-relaxed" style={{ color: '#15354F' }}>
            {String(message || '').replace(/[\u2026.]+$/, '')}
          </p>
          <span className="inline-flex gap-[3px]">
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#46A8F9', animation: 'orellaThinkDot 1.2s infinite 0s' }} />
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#46A8F9', animation: 'orellaThinkDot 1.2s infinite .2s' }} />
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#46A8F9', animation: 'orellaThinkDot 1.2s infinite .4s' }} />
          </span>
        </div>
        {subMessage ? (
          <p className="text-[13.5px] leading-relaxed mt-1.5" style={{ color: '#5B6B7B' }}>{subMessage}</p>
        ) : null}
      </div>
    </div>
  )
}
